/* =============================================================================
=    Register
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
mutation updateProfile($profileForm: profileFormInput!) {
  updateProfile(profileForm: $profileForm) {
   id
   email
 }
}
`;
